import AgoraRTC, { ClientConfig } from 'agora-rtc-sdk-ng';

export const config: ClientConfig = { mode: 'rtc', codec: 'vp8' };

export const useAgoraClient = () => AgoraRTC.createClient(config);
